import React from 'react'

import { SvgWrapper } from './SvgWrapper/SvgWrapper'

export const OrientationActiveSvg = ({ size = 24 }) => (
  <SvgWrapper size={size}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23Z"
      fill="url(#paint0_linear-orientation)"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.8198 6.77197C18.0662 6.29738 17.5517 5.78935 17.0803 6.04167L10.2966 9.67237C9.91054 9.879 9.59579 10.1973 9.3935 10.5857L5.97435 17.1501C5.73027 17.6187 6.23013 18.1251 6.70186 17.8871L13.3193 14.5487C13.7272 14.3429 14.0599 14.014 14.2704 13.6085L17.8198 6.77197Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear-orientation"
        x1="48.4203"
        y1="25.776"
        x2="22.5544"
        y2="-25.0646"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#79D2D3" />
        <stop offset="1" stopColor="#2DBEBF" />
      </linearGradient>
    </defs>
  </SvgWrapper>
)
